module.exports = __webpack_public_path__ + "img/icons-24-support.3f8db152.svg";